export default "__VITE_ASSET__BgL9_MQs__"